import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCapsuleInherit = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M2.79505 7.84099C1.40165 6.44759 1.40165 4.18845 2.79505 2.79505C4.18845 1.40165 6.44759 1.40165 7.84099 2.79505L11.205 6.15901C12.5983 7.55241 12.5983 9.81155 11.205 11.205C9.81155 12.5983 7.55241 12.5983 6.15901 11.205L2.79505 7.84099Z",
			stroke: "#9999A4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.9165 4.66675L4.6665 9.91675",
			stroke: "#9999A4"
		})
	]
});
const ForwardRef = forwardRef(SvgCapsuleInherit);
export { ForwardRef as ReactComponent };
